var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioUncheckedSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0007 23.3333C11.5253 23.3333 9.15133 22.35 7.40099 20.5997C5.65065 18.8493 4.66732 16.4754 4.66732 14C4.66732 11.5247 5.65065 9.15069 7.40099 7.40035C9.15133 5.65001 11.5253 4.66668 14.0007 4.66668C16.476 4.66668 18.85 5.65001 20.6003 7.40035C22.3507 9.15069 23.334 11.5247 23.334 14C23.334 16.4754 22.3507 18.8493 20.6003 20.5997C18.85 22.35 16.476 23.3333 14.0007 23.3333ZM14.0007 2.33334C12.4686 2.33334 10.9515 2.63511 9.53601 3.22142C8.12055 3.80772 6.83442 4.66708 5.75107 5.75043C3.56315 7.93836 2.33398 10.9058 2.33398 14C2.33398 17.0942 3.56315 20.0617 5.75107 22.2496C6.83442 23.3329 8.12055 24.1923 9.53601 24.7786C10.9515 25.3649 12.4686 25.6667 14.0007 25.6667C17.0948 25.6667 20.0623 24.4375 22.2502 22.2496C24.4382 20.0617 25.6673 17.0942 25.6673 14C25.6673 12.4679 25.3656 10.9508 24.7792 9.53537C24.1929 8.1199 23.3336 6.83378 22.2502 5.75043C21.1669 4.66708 19.8808 3.80772 18.4653 3.22142C17.0498 2.63511 15.5327 2.33334 14.0007 2.33334Z",
    fill: "#131313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioUncheckedSvg);
export default __webpack_public_path__ + "static/media/radio-unchecked-svg.685bd09efbba29ffe47d078f21be86b8.svg";
export { ForwardRef as ReactComponent };